module.exports = __webpack_public_path__ + "img/themisColor.d8dc8667.png";